<template>
  <div v-if="open" class="terms-modal">
    <div class="terms-modal__backdrop" @click="close"></div>
    <div class="terms-modal__content">
      <div class="terms-modal__header">
        <h3>Términos y condiciones Olimpiadas Mobius 2026</h3>
        <button class="terms-modal__close" @click="close">✕</button>
      </div>
      <div class="terms-modal__body">
        <p class="terms-intro">
          Los presentes Términos y Condiciones regulan la participación en las Olimpiadas Mobius 2026 (en adelante, “la Olimpiada”), organizadas por Mobius (en adelante, “Mobius”).
        </p>
        <p class="terms-intro">
          La inscripción y participación en la Olimpiada implican la aceptación plena y sin reservas de los siguientes términos.
        </p>

        <h4>1. Naturaleza de la competencia</h4>
        <p>La Olimpiada es una actividad gratuita, de carácter educativo, desarrollada en modalidad 100 % online, dirigida a estudiantes hispanohablantes.</p>

        <h4>2. Requisitos de participación</h4>
        <p>La competencia está dirigida exclusivamente a estudiantes menores de 18 años al momento de la inscripción.</p>
        <p>Mobius asume que el estudiante menor de edad es autorizado por su padre, madre o acudiente legal para participar en la Olimpiada quienes aceptan reglamentos y términos y condiciones.</p>
        <p>Mobius podrá solicitar documentación que permita verificar la edad y la identidad del participante.</p>

        <h4>3. Fechas oficiales</h4>
        <ul>
          <li>Fase clasificatoria: 3 de mayo de 2026</li>
          <li>Gran Final: 24 de mayo de 2026</li>
        </ul>
        <p>Mobius se reserva el derecho de modificar estas fechas por causas justificadas, comprometiéndose a informar oportunamente a los participantes por los canales oficiales.</p>

        <h4>4. Modalidad y reglas de calificación</h4>
        <p>La Olimpiada se desarrolla en modalidad virtual, bajo las condiciones técnicas y académicas definidas por Mobius.</p>
        <p>La clasificación se realiza con base en el puntaje obtenido, calculado a partir del desempeño del estudiante en las pruebas correspondientes.</p>
        <p>En la fase clasificatoria, clasifica el 50 % de los participantes con mayor puntaje.</p>
        <p>La Gran Final se desarrolla en dos rondas:</p>
        <ul>
          <li>Un primer examen con los estudiantes clasificados, tras el cual se anuncian en tiempo real los 20 mejores puntajes.</li>
          <li>Un segundo examen que define los tres (3) primeros lugares de la Olimpiada.</li>
        </ul>
        <p>Mobius se reserva el derecho de descalificar a cualquier participante que incumpla las reglas académicas, técnicas o éticas del evento.</p>

        <h4>5. Premios</h4>
        <p>Los premios anunciados para la Olimpiada son:</p>
        <ul>
          <li>Primer lugar: USD 400</li>
          <li>Segundo lugar: USD 200</li>
          <li>Tercer lugar: USD 100</li>
        </ul>
        <p>Adicionalmente, los colegios de los estudiantes que ocupen los tres primeros lugares recibirán membresías Mobius gratuitas, conforme a las condiciones que Mobius defina para dicho beneficio.</p>
        <p>La entrega de premios a menores de edad se realizará únicamente con la autorización y acompañamiento de sus padres o acudientes legales, y mediante los mecanismos que Mobius considere seguros y adecuados según el país del ganador.</p>

        <h4>6. Uso y protección de datos personales</h4>
        <p>Mobius protege la información personal de los participantes, especialmente la de menores de edad.</p>
        <p>Los datos personales serán utilizados exclusivamente para la gestión de la Olimpiada y fines educativos asociados, de conformidad con la normativa aplicable en materia de protección de datos.</p>
        <p>Al inscribirse, el participante y su acudiente autorizan a Mobius a realizar comunicaciones relacionadas con la Olimpiada a través de correo electrónico y WhatsApp.</p>

        <h4>7. Uso de imagen y testimonios</h4>
        <p>La publicación de nombres, imágenes, videos o testimonios de los participantes se realizará únicamente con la autorización previa, expresa y verificable de los padres o acudientes legales.</p>

        <h4>8. Declaración de independencia de plataformas externas</h4>
        <p>Esta actividad no está patrocinada, avalada, administrada ni asociada con Instagram ni con Meta Platforms, Inc.</p>
        <p>Instagram no es un canal oficial de atención, soporte ni comunicación de la Olimpiada. Para consultas oficiales, los participantes deberán utilizar únicamente los canales de contacto indicados en la página web de Mobius.</p>

        <h4>9. Transparencia y descalificación</h4>
        <p>Mobius garantiza un proceso transparente y justo. No obstante, se reserva el derecho de descalificar participantes que incurran en conductas que vulneren las reglas académicas, técnicas, éticas o de integridad de la Olimpiada, sin que ello genere derecho a reclamo alguno.</p>

        <h4>10. Modificaciones</h4>
        <p>Mobius podrá modificar estos Términos y Condiciones cuando existan razones justificadas, informando oportunamente a los participantes a través de los canales oficiales.</p>
      </div>
      <div class="terms-modal__footer">
        <button class="mob-btn mob-cta-gold" @click="close">
          Entendido
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OlimpiadasTermsModal",
  props: {
    open: Boolean,
  },
  emits: ["close"],
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.terms-modal {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 72px;
  padding-bottom: 24px;
  box-sizing: border-box;
}

.terms-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 18, 28, 0.6);
}

.terms-modal__content {
  position: relative;
  z-index: 1;
  width: min(760px, 92vw);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 24px 48px rgba(23, 30, 52, 0.2);
}

.terms-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.terms-modal__close {
  border: none;
  background: #f2f3f7;
  border-radius: 10px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.terms-modal__body {
  color: #1d2433;
  font-size: 14px;
  line-height: 1.55;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  padding-right: 4px;
}

.terms-intro {
  margin-bottom: 16px;
  font-weight: 500;
}

.terms-modal__body h4 {
  font-size: 15px;
  font-weight: 700;
  color: #1d2433;
  margin: 20px 0 10px 0;
}

.terms-modal__body h4:first-of-type {
  margin-top: 0;
}

.terms-modal__body p {
  margin: 0 0 10px 0;
}

.terms-modal__body ul {
  padding-left: 20px;
  margin: 8px 0 12px 0;
}

.terms-modal__body li {
  margin-bottom: 6px;
}

.terms-modal__footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.terms-modal__primary {
  border: none;
  background: #656ec9;
  color: #ffffff;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 12px;
  cursor: pointer;
}
</style>
